export default __webpack_public_path__ + "static/char-v-56-zh-Hant-db150f729e510fd5f5119a70fbcfaba7.mp4";